import D2C_ProviderStorage from './Storage'

class D2C_ProviderSpaces extends D2C_ProviderStorage {
  static objectType = 'providerType'
  static active = true
  static order = 33
  static providerType = 'Spaces'
  static providerTitle = 'DigitalOcean Spaces'
  static fields = {
    ...D2C_ProviderStorage.fields,
    bucket: {
      default: '',
      label: 'Spaces',
      path: 'auth.bucket',
      required: true,
      validate() {
        return null
      },
      creating: {},
    },
    accessId: {
      default: '',
      label: 'Access ID',
      path: 'auth.accessId',
      required: true,
      validate(value) {
        return /^[A-Z0-9]{20}$/.test(value) ? null : 'Must contain 20 letters or numbers'
      },
      creating: {},
    },
    secretKey: {
      default: '',
      label: 'Secret key',
      path: 'auth.secretKey',
      required: true,
      validate(value) {
        return /^[A-Za-z0-9/+=]{40,45}$/.test(value) ? null : 'Must contain 40-45 symbols'
      },
      creating: {},
    },
    region: {
      label: 'Region',
      path: 'auth.region',
      required: true,
      width: 16,
      enum: ['ams3', 'fra1', 'nyc3', 'sfo2', 'sgp1'],
      validate(value) {
        return value ? null : 'Must be selected'
      },
      creating: {},
    },
  }
}

export default D2C_ProviderSpaces
